import { configureStore, combineReducers } from "@reduxjs/toolkit"
import storage from "redux-persist/lib/storage"
import { persistReducer, persistStore, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from "redux-persist"

import authReducer from "./reducers/auth"
import teamReducer from "./reducers/team"
import destinationsReducer from "./reducers/destinations"
import activitiesReducer from "./reducers/activities"
import campaignsReducer from "./reducers/campaigns"
import feedbackReducer from "./reducers/feedback"

const rootReducer = combineReducers({
  auth: authReducer,
  team: teamReducer,
  destinations: destinationsReducer,
  activities: activitiesReducer,
  campaigns: campaignsReducer,
  feedback: feedbackReducer
})

const persistConfig = {
  key: "root",
  storage
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore redux-persist action types
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
      }
    }),
  devTools: process.env.NODE_ENV !== "production"
})

export const persistor = persistStore(store)

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
